export interface Media {
  id: string;
  description: string;
  mediaType: EMediaType;
  MIMEType: string;
  mediaFiles: MediaFile[];
}

export interface MediaFile {
  id: string;
  url: string;
  sizeType: ESizeType;
}

export enum EMediaType {
  Image = "Image",
  Video = "Video",
}

export enum ESizeType {
  Large = "Large",
  Medium = "Medium",
  Small = "Small",
  Thumbnail = "Thumbnail",
  Original = "Original",
}
